import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";
import { startRegisterSearchResult } from "./searchResultActions";
import { dispatchSearchFilterResults } from "../helpers/searchFilterDispatch.helper";
import { resolveFlowListQueryFromState } from "../helpers/flowModuleListQueryHelper";

export const innovationStartRegisterAdmin = (innovation, navigate, returnTo) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_INNOVATION}`,
      "add",
      innovation,
      "POST"
    );

    const body = await resp.json();

     debugLogActions(':: innovationActions, innovationStartRegisterAdmin', { 'body': body });

    if (body.ok) {

      const innovationSaved = body.innovation;

      dispatch(innovationRegisterAdmin(innovationSaved));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            const nextPath = typeof returnTo === "string" && returnTo.startsWith("/")
              ? returnTo
              : "/specialist-innovation";
            navigate(nextPath);
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const innovationRegisterAdmin = (innovation) => ({
  type: types.INNOVATION_START_REGISTER_ADMIN,
  payload: innovation,
});

export const innovationStartUpdate = (innovation, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_INNOVATION}`,
        `update/${innovation.id}`,
        innovation,
        "PUT"
      );
      const body = await resp.json();

       debugLogActions(':: innovationActions, innovationStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(innovationUpdated(innovation));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        });

      } else {

        if (body.errors) {
          const { catalogserie_id } = body.errors;

          if (catalogserie_id) {
            Swal.fire(t("titles.error"), catalogserie_id.msg, "error");
            
          }
        }

        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: innovationActions, innovationStartUpdate', { 'error': error });
    }
  };
};

const innovationUpdated = (innovation) => {
  return {
    type: types.INNOVATION_UPDATE,
    payload: innovation,
  };
};

export const innovationStartDelete = (id, onDeleted) => {
  return async (dispatch, getState) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_INNOVATION}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {

               debugLogActions(':: innovationActions, innovationStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(innovationDeleted(id));
                if (typeof onDeleted === "function") {
                  onDeleted();
                }
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: innovationActions, innovationStartDelete', { 'error': error });
    }
  };
};

const innovationDeleted = (id) => {
  return {
    type: types.INNOVATION_DELETE,
    payload: id,
  };
};

export const startLoadingInnovationsPaginated = (page, size) => {
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'innovation');
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_INNOVATION}`, `get/${page}/${size}${query}`);
    const body = await resp.json();

     debugLogActions(':: innovationActions, startLoadingInnovationsPaginated', { 'body': body });

    if (body.ok) {
      dispatch(loadingInnovationsPaginated(body.innovationsPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingInnovationsPaginated = (innovationsPaginated) => ({
  type: types.INNOVATION_START_LOADING_PAGINATED,
  payload: innovationsPaginated,
});

export const startLoadingInnovationsByTextInnovationPaginated = (innovation, page, size, catalogToFilter, indicatorToFilter = [], codeCiiuLevel1={}) => {
  return async (dispatch, getState) => {

     const searchInfo = {
      searchInnovationText: innovation,
      codeCiiuLevel1: codeCiiuLevel1,
      catalogToFilter: catalogToFilter,
      indicatorToFilter: indicatorToFilter,
    };

    dispatch(innovationIsLoading());

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_INNOVATION}`,
      `getByTextInnovation/${page}/${size}`,
      searchInfo,
      "POST"
    );
    const body = await resp.json();

     debugLogActions(':: innovationActions, startLoadingInnovationsByTextInnovationPaginated', { 'body': body });

    if (body.ok) {

      dispatch(innovationIsLoadingFinish());

      dispatchSearchFilterResults(dispatch, body.filterResults);

      body.innovationsPaginated.innovationsP.forEach(element => {
        element.isSelected = false;
        element.isCompared = false;
      });

      dispatch(loadingInnovationsByTextInnovationPaginated(body.innovationsPaginated));

      const { totalItems, totalPages, currentPage, innovationsP } = body.innovationsPaginated;
      
            let index = 0;
            let registerIds = "";
            innovationsP.forEach(element => {
      
              if (index === 0) {
                registerIds = registerIds.concat(element.id);
              } else {
                registerIds = registerIds.concat(";", element.id);
              }
      
              index = index + 1;
            });
      
            const state = getState();
            const { searchInfo } = state.searchInfo;
      
            const searchResult = {
              filter_results: body.filterResults,
              total_items: totalItems,
              total_pages: totalPages,
              current_page: currentPage,
              search_results_ids: registerIds,
              deleted: false,
              searchinfo_id: searchInfo.id
            }
      
            dispatch(startRegisterSearchResult(searchResult));

    } else {

      dispatch(innovationIsLoadingFinish());
      
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingInnovationsByTextInnovationPaginated = (innovationsPaginated) => ({
  type: types.INNOVATION_START_LOADING_INNOVATION_PAGINATED,
  payload: innovationsPaginated,
});

export const startSearchingInnovationsPaginated = (textSearch, page, size) => {
  
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'innovation');
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_INNOVATION}`,
      `search/${textSearch}/${page}/${size}${query}`
    );
    const body = await resp.json();

     debugLogActions(':: innovationActions, startSearchingInnovationsPaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingInnovationsPaginated(body.innovationsPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const searchingInnovationsPaginated = (innovationsPaginated) => ({
  type: types.INNOVATION_START_SEARCH_PAGINATED,
  payload: innovationsPaginated,
});

export const selectInnovation = (innovation) => ({
  type: types.INNOVATION_SELECT,
  payload: innovation,
});

export const cleanInnovationsPaginatedS = () => ({
  type: types.INNOVATION_CLEAN_SEARCH_PAGINATED,
});

export const cleanInnovationsPaginatedP = () => ({
  type: types.INNOVATION_CLEAN_PAGINATED,
});

export const innovationSetSearchText = (searchText) => ({
  type: types.INNOVATION_SET_SEARCH_TEXT,
  payload: searchText,
});

export const innovationCleanSearchText = () => ({
  type: types.INNOVATION_CLEAN_SEARCH_TEXT,
});

export const innovationCleanSaved = () => ({
  type: types.INNOVATION_CLEAN_SAVED,
});

//Si van Update 13 de Feb 2026
export const innovationListUpdateSelected = (id) => ({
  type: types.INNOVATION_LIST_UPDATE_SELECTED,
  payload: id
});

export const innovationListSelectAllLimit = () => ({
  type: types.INNOVATION_SELECT_ALL_LIMIT,
});

export const innovationCleanAllSelected = () => ({
  type: types.INNOVATION_CLEAN_ALL_SELECTED,
});

export const innovationCleanAllSelectedWithoutList = () => ({
  type: types.INNOVATION_CLEAN_ALL_WITHOUT_LIST,
});

export const innovationIsLoading = () => ({
  type: types.INNOVATION_IS_LOADING
});

export const innovationIsLoadingFinish = () => ({
  type: types.INNOVATION_IS_LOADING_FINISH
});


//No van Update 13 de Feb 2026
export const innovationGetMoreThanOneIsSelected = () => ({
  type: types.INNOVATION_GET_MORE_THAN_ONE_SELECTED
});

export const innovationGetNumberInnovationSelected = (countCompareFlag) => ({
  type: types.INNOVATION_LIST_SET_NUMBER_SELECTED,
  payload: countCompareFlag
});

export const cleanSearchInformation = () => ({
  type: types.INNOVATION_CLEAN_SEARCH_INFORMATION,
});